import { useForm } from '@mantine/form';
import { useState } from 'react';
import type { UpsertRearDisplayDto } from '../types/RearDisplayDto';
import { validateDate, validateEndDate, validateText } from '../../../util/validation/commonValidation';

export type NewGroupDto = {
	groupName: string;
};

const defaultRearDisplay: UpsertRearDisplayDto = {
	id: '0',
	file: undefined,
	description: '',
	branchIds: [],
	startDate: undefined,
	endDate: undefined,
	isEdit: false,
};

export function useUpsertRearDisplayForm(
	rearDisplay: UpsertRearDisplayDto = defaultRearDisplay,
) {
	const [inputs, setInputs] = useState<UpsertRearDisplayDto>(rearDisplay);

	const form = useForm<UpsertRearDisplayDto>({
		mode: 'uncontrolled',
		initialValues: rearDisplay,
		validate: {
			startDate: (value) => validateDate(value, false),
			endDate: (value, values: UpsertRearDisplayDto) =>
				validateEndDate(value, false, values.startDate),
			file: (value, values) => {
				if (values.isEdit) return;

				if (!value) {
					return 'Please select a file';
				}
				if (value instanceof File && value.size >= 16000000) {
					return 'File size must be less than 15 MB';
				}
			},
			branchIds: (value) => {
				if (!value || value.length < 1) {
					return 'Please select at least one branch';
				}
			},
			description: (value) => validateText(value, false, 'Description', 50),
		},
		onValuesChange: (v) => setInputs(v),
	});

	return { form, inputs };
}
